<template>
  <div class="editor-area" :class="pageClass" :style="widthHeightCalcStyle" @click.stop>
    <div class="scale-box" :class="renderContainerClass" :style="renderContainerStyle">
      <template v-for="(item, index) in editorObj.data">
        <div v-if="item.type === 'img'"
             class="area-item-img-box area-item"
             :class="itemCommonClass(item, index)"
             :style="getStyle(item, index)"
             :key="'img' + index"
             :title="item.missingFont ? '缺失字体':''"
             @click="onImgClick(item, index)"
             @dblclick.stop="onImgDblclick(item, index)">
          <el-popover :key="index"
                      :disabled="disabledEditorOperation(item)"
                      placement="top"
                      title=""
                      width="200"
                      trigger="hover"
                      :visible-arrow="false"
                      popper-class="editor-area-popover">
            <div class="img-edit-header" :key="`imgEdit${index}`">
                                <span class="ea-icon" v-if="allowCut(item)" @click="showImgEditor(index, item)">
                                    <i class="icon1-font icon1-cut"></i>裁剪</span>
              <span class="ea-icon" v-if="item.allowHide" @click="onHide(index, item)">
                                     <span v-if="item.hide"> <i class="icon1-font icon1-show"></i>显示</span>
                                     <span v-else><i class="icon1-font icon1-hide"></i>隐藏</span>
                                </span>
              <span class="ea-icon" v-if="item.isGroupMaterial && hasGroupMaterial"
                    @click="onOpenGroupDialog(index, item)">
                                    <i class="icon1-font icon1-jigsaw"></i>拼图</span>
            </div>
            <div slot="reference">
              <div class="img-box-body" :class="{'material-group-box': item.materialGroup}">
                <span class="area-item-size" v-if="isImgHeaderEdit(item, index)" :key="`span${index}`">尺寸{{item.width}}*{{item.height}}</span>
                <img v-if="showImg(item) && !isGroupMaterial(item)" class="area-item-img"
                     :src="item.url"
                     :class="renderImgClass(item)"
                     :style="imgStyle(item)"
                     @drop.stop="onDrop($event, item, index)"
                     @dragover="onAllowDrop($event, item, index)"
                     @dragleave="onDragleave"
                     @dragenter="onDragenter"
                     @dragend="onDragend"
                     @load="onImgLoad(item)"
                     draggable="false" :alt="item.originName"/>
                <img-template :key="item.key" v-if="showImg(item) && isGroupMaterial(item)"
                              class="material-group-img"
                              :size="{width: item.width, height: item.height}"
                              :data="item.materialGroup">
                </img-template>
                <div class="action-button" v-show="!item.showImg && item.isActionBg"
                     :style="actionBgStyle(item)"></div>
                <div v-if="showImg(item) && item.coverObj" :style="calcImgCoverStyle(item)"></div>
              </div>
            </div>
          </el-popover>
        </div>
        <span class="area-item text-item"
              :alt="item.originName"
              v-else-if="item.type === 'text'"
              v-text="item.name"
              :key="'text' + index" :style="getStyle(item, index)"
              :class="itemCommonClass(item, index)"
              draggable="false"
              @dragover="onTextAllowDrop($event, item)"
              spellcheck="false"
              @paste="onPaste($event, item)"
              :contenteditable="edit && !item.disabled"
              @blur="onEditorTextBlur($event, item, index)"
              @focus="onEditorTextFocus($event, item, index)"
              @click.stop="onTextClick($event, item, index)"
              @keydown="onTextKeydown($event, item, index)"
              @keyup="onKeyup($event, item, index)"
              @input.stop="onTextInput($event, item, index)"
        />
      </template>
      <div v-if="activeCover" :style="coverStyle" class="attr-img-cover"></div>
    </div>
  </div>
</template>
<script>
    import {empty_template, img_horizontal, img_vertical, img_two_direction} from '@/const.js';
    import imgTemplate from '../img-template/index';
    import util from '@/util.js';
    import uploadService from '@/request/service/fileupload-service';
    export default {
        components: {imgTemplate},
        props: {
            value: {
                type: Object,
                default() {
                    return {};
                }
            },
            scale: {
                type: Number, default: 1
            },
            edit: {
                type: Boolean,
                default: true
            },
            showSize: {
                type: Boolean,
                default: false
            },
            activeCover: {
                type: Boolean,
                default: false
            },
            coverIndex: null,
            hasGroupMaterial: {
                type: Boolean,
                default: false
            },
            layerResize: {
                type: Boolean, default: false
            },
            preview: {
                type: Boolean, default: false
            },
            tplProjectId: String
        },
        data() {
            return {
                editorObj: JSON.parse(JSON.stringify(empty_template)).json,
                activeIndex: {},
                inputEnd: true,
                showEditorOperation: true,
                errorItem: null
            }
        },
        computed: {
            pageClass(){
                let classArr = [];
                let {customSize} = this.editorObj;
                if(customSize && customSize.width){
                    classArr.push('custom-size');
                }
                if(this.preview){
                    classArr.push('editor-preview');
                }
                return classArr.join(' ');
            },
            scalePercent() {
                return this.scale * 100;
            },
            widthHeightCalcStyle() {
                let editorObj = this.editorObj;
                let bgStyle = editorObj.backgroundColor;
                if (bgStyle && bgStyle.indexOf('background') > -1) {
                    bgStyle = bgStyle.split(':')[1];
                }
                let height = parseFloat(editorObj.height) * this.scale;
                let width = parseFloat(editorObj.width) * this.scale;
                if (editorObj.customSize && editorObj.customSize.width) {
                    width = editorObj.customSize.width;
                    height = editorObj.customSize.height
                }
                return `backgroundColor: ${bgStyle}; height:${height}px;width:${width}px;`
            },
            renderContainerClass(){
                if(this.isOpacityBg(this.editorObj.backgroundColor)){
                    return 'c-opacity-bg';
                }
                return null;
            },
            renderContainerStyle() {
                let editorObj = this.editorObj;
                let scale = this.scale;
                let height = parseFloat(editorObj.height);
                let width = parseFloat(editorObj.width);
                return `height:${height}px;width:${width}px;transform: scale(${scale});transform-origin: left top;`
            },
            editorSelectedImgIdx() {
                return this.$store.state.app.editorSelectedImgIdx;
            },
            coverStyle() {
                let item = this.selectedItem;
                if (item) {
                    // 扩大选中的背景边框
                    let addVal = 10;
                    let width = parseFloat(item.width) + addVal;
                    let height = parseFloat(item.height) + addVal;
                    let top = parseFloat(item.top) - addVal / 2;
                    let left = parseFloat(item.left) - addVal / 2;
                    return `z-index: ${200};left: ${left}px;top: ${top}px;width:${width}px;height:${height}px`;
                }
                return 'display:none';
            },
            selectedItem() {
                return this.$store.state.templateGroup.selectedItem;
            }
        },
        watch: {
            value: {
                handler() {
                    this.init();
                },
                deep: true,
                immediate: true
            },
            editorSelectedImgIdx(index) {
                this.activeIndex = {};
                this.$set(this.activeIndex, index, true);
            }
        },
        created() {
        },
        methods: {
            init() {
                Object.assign(this.editorObj, this.value);
                if(!this.preview){
                    this.bindEvent();
                }
                if(this.tplProjectId){
                    this.loadingFont();
                }
            },
            async loadingFont() {
                let fontArr = new Set(), fontF;
                this.editorObj.data.forEach((item) => {
                    if (item.type === 'text') {
                        let ffList = item.fontFamily.split(',');
                        ffList.forEach((ff) => {
                            fontF = ff.trim();
                            if (fontF) {
                                fontArr.add(fontF);
                            }
                        })
                    }
                });
                util.appendFontStyle(this.tplProjectId, [...fontArr]);
            },
            getFontUrl(fontFamily) {
                let fontList = this.$store.state.app.projectFontList;
                let fontUrl = fontList.filter((item) => {
                    return item.name === fontFamily;
                })[0].url;
                return fontUrl;
            },
            bindEvent() {
                document.body.addEventListener('click', this.clearActiveSelected)
            },
            notBlur(className) {
                return className.indexOf('not-blur-editor-area') > -1;
            },
            clearActiveSelected(evt) {
                if (!evt) {
                    return;
                }
                let className = evt.target.className;
                if (className && className.indexOf('clear-index') > -1) {
                    this.$store.commit('app/set_selected_img_index', null);
                }
            },
            disabledEditorOperation(item) {
                return item.disabled || this.preview || !((this.allowCut(item) || (item.isGroupMaterial && this.hasGroupMaterial) || item.allowHide));
            },
            isImgHeaderEdit(item, index) {
                let isActive = !!this.activeIndex[index];
                return !this.preview && isActive && !item.hide && !item.disabled && this.showEditorOperation;
            },
            allowCut(item) {
                return !item.hide && !this.isGroupMaterial(item) && !item.disabled;
            },
            imgStyle(item) {
                if (item.isCircle) { // 兼容老模板是数值字符类型
                    return 'border-radius: 50%';
                } else if (item.borderRadius) {
                    return `border-radius: ${item.borderRadius}px`;
                }
                return 'border-radius: 0px';
            },
            isBg(item) {
                return item.isBgImg || item.isPageBgImg;
            },
            showImg(item) {
                return item.showImg || item.showImg === null || item.showImg === undefined;
            },
            renderImgClass(item){
                let classArr = [];
                if(this.isBg(item)){
                  classArr.push('item-bg-img');
                }
                return classArr.join(' ');
            },
            calcImgCoverStyle(item){
                let {color, url} = item.coverObj;
                if(!color && !url){
                    return '';
                }
                let bg = url ? `background-image: url(${url});background-size: 100% 100%;` : `background-color: ${color}`;
                return `pointer-events: none;${bg};top: 0px;left:0px;width:${item.width}px;height: ${item.height}px;position: absolute;z-index: 1`
            },
            isOpacityBg(color){
                return color === 'rgba(0,0,0,0)';
            },
            itemCommonClass(item, index) {
                let className = [];
                let isOpacityLayer = this.isOpacityBg(this.editorObj.backgroundColor) && this.isBg(item);
                if (item.hide || isOpacityLayer) {
                    className.push('c-hide')
                }
                if (!this.preview && !item.disabled) {
                    let isActive = !!this.activeIndex[index];
                    if (isActive) {
                        className.push('active-hover')
                    }
                    if (!this.isBg(item)) {
                        className.push('mouse-hover');
                    }
                    let dct = item.direction;
                    if (dct) {
                        className.push(dct);
                    }
                }
                if (item.missingFont) {
                    className.push('c-missing-font');
                }
                if(this.errorItem === item){
                    className.push('more-text-error');
                }
                return className.join(' ');
            },
            getLetterSpacing(letterSpacing) {
                if (!letterSpacing || letterSpacing === 'normal') {
                    return null;
                }
                if (isNaN(letterSpacing) && letterSpacing.indexOf('px') > -1) {
                    letterSpacing = letterSpacing.split('px')[0];
                }
                return parseFloat(letterSpacing);
            },
            inEditorForTextVertical(item) {
                /**
                 * 编辑器中的文字，不需要设置宽度
                 * 面板中的文字需要固定宽度，文字拖入时，组件需要固定宽度值
                 */
                return ['vertical-lr', 'vertical-rl'].indexOf(item.writingMode) > -1 && !this.layerResize;
            },
            isNotNull(value) {
                return value !== null && value !== undefined;
            },
            getStyle(item, index) {
                //isDragText 面板页已选中可手动的文本
                let isDragText = this.layerResize && item.type === 'text';
                let left = isDragText ? 0 : item.left;
                let top = isDragText ? 0 : item.top;
                let zIndex = this.isNotNull(item.zIndex) ? (+item.zIndex + 1) : index + 1;
                if(isDragText){
                    zIndex = 0;
                }
                if (item.type === 'text') {
                    let fontSize = parseFloat(item.fontSize);
                    let width = parseFloat(item.width);

                    let scaleW;
                    if (item.scale && item.scale.toString().indexOf(',') > -1) {
                        scaleW = parseFloat(item.scale.split(',')[0]);
                        fontSize = parseInt(scaleW * fontSize)
                    }
                    let letterSpacing = this.getLetterSpacing(item.letterSpacing);
                    if (letterSpacing) { // 有字符间距时，宽度偏小
                        width += letterSpacing + 5;
                    } else {
                        width += Math.ceil(fontSize / 10);
                    }
                    letterSpacing = letterSpacing ? letterSpacing : 'normal';
                    let lineHeight = this.getLineHeight(item);
                    if (lineHeight) {
                        lineHeight = `${lineHeight}px`;
                    } else {
                        lineHeight = 'normal';
                    }
                    width = `${width}px`;
                    if (item.tagName || this.inEditorForTextVertical(item)) {
                        width = 'auto';
                    }
                    let textFontArray = [
                        `text-align:${item.textAlign}`,
                        `min-width: 20px`,
                        `transform-origin: ${item.transformOrigin}`,
                        // `transform:matrix(${item.matrix.join(',')})`,
                        // `transform:scale(${item.scale})`,
                        `padding:${item.padding || 0 }px`,
                        `${item.backgroundColor || 'background-color: none'}`, // 老的写法，现在不再使用
                        `background:${item.background}`,
                        `font-family:${item.fontFamily}`,
                        `font-size: ${fontSize}px`,
                        `font-style: ${item.fontStyle}`,
                        `font-weight: ${item.fontWeight}`,
                        `color:${item.color}`,
                        `letter-spacing: ${letterSpacing}px`,
                        `line-height: ${lineHeight}`,
                        `display: block`,
                        `width: ${width}`,
                        `text-shadow: ${item.textShadow}`,
                        `writing-mode: ${item.writingMode}`,
                        `text-decoration:${item.textDecoration || 'none'}`
                    ];
                    let baseStyle = [
                        `opacity: ${item.opacity}`,
                        `z-index: ${zIndex}`,
                        `top: ${top}px`,
                        `left: ${item.left}px`
                    ]
                    if (['vertical-lr', 'vertical-rl'].indexOf(item.writingMode) > -1) {
                        baseStyle.push(`height: ${item.height}px`);
                    }
                    return baseStyle.join(';') + ';' + textFontArray.join(';');
                } else {
                    let width = item.width + 'px';
                    let height = item.height + 'px';
                    let imgArray = [
                        `opacity: ${item.opacity}`,
                        `z-index: ${zIndex}`,
                        `left: ${left}px`,
                        `top: ${top}px`,
                        `width: ${width}`,
                        `height: ${height}`,
                    ]
                    return imgArray.join(';');
                }
            },
            getLineHeight(item) {
                if (item.isMoreRow || ['vertical-lr', 'vertical-rl'].indexOf(item.writingMode) > -1) {
                    return item.lineHeight;
                } else {
                    return item.height; // 单行文本使用height做lineHeight, 保证文本上下不会出现空白间距
                }
            },
            actionBgStyle(item) {
                let ra = null;
                if (item.isCircle) { // 老模板存的是数值，现在存的是true or false 表示是否使用50%
                    ra = '50%';
                } else if (item.borderRadius) {
                    ra = `${item.borderRadius}px`;
                }
                let style = [
                    `border-radius: ${ra}`,
                    `background-color:${item.backgroundColor}`
                ];
                return style.join(';');
            },
            getSizeStyle(item) {
                let left = item.left + 'px';
                let top = item.top + 'px';
                return `left: ${left};top: ${top};`;
            },
            onPaste(event, item) {
                event.preventDefault();
                event.stopPropagation();
                if (event.clipboardData.types.indexOf('Files') > -1) {
                    return;
                }
                let pasteText = null;
                if (event.clipboardData && event.clipboardData.getData) {
                    pasteText = event.clipboardData.getData('text/plain');
                } else if (window.clipboardData && window.clipboardData.getData) {
                    pasteText = window.clipboardData.getData('Text');
                }
                this.validateTextLen(event, item);
                if (document.queryCommandSupported('insertText')) {
                    document.execCommand('insertText', false, pasteText);
                } else {
                    document.execCommand('paste', false, pasteText);
                }
            },
            onEditorTextBlur($event, item, index) {
                this.inputting = false;
                if (item.disabled) {
                    return;
                }
                this.validateTextLen($event, item);
                this.$emit('onEditorTextBlur', $event, index);
                this.activeIndex[index] = false;
                this.textHeight = null;
                let newWidth = $event.target.offsetWidth;
                let newHeight = $event.target.offsetHeight;
                this.$nextTick(() => {
                    if (item.tagName) {
                        this.autoExtend(newWidth, newHeight, item);
                    } else {
                        // 补充旧模板上传时，没有originData
                        item.originData = item.originData || {};
                        if (!item.originData.height) {
                            item.originData.height = item.height;
                        }
                        let hasEnter = $event.target.textContent.indexOf('\n') > -1;
                        if (hasEnter && !item.isMoreRow && item.originData.height) { // 行高使用fontSize，两行紧挨着
                            item.lineHeight = item.originData.height;
                            item.isMoreRow = true;
                        }
                        item.height = newHeight;
                        item.bottom = +item.height + (+item.top);
                        if(this.textWidth !== newWidth){
                            item.width = newWidth;
                            item.right = +item.width + (+item.left);
                        }
                    }
                })
            },
            setItem(imgItem, textItem, newWidth, center) {
                if (center && imgItem.direction === img_horizontal) { // 文本设置为居中，图片扩展时要保持文字和图片相对位置居中,水平扩展才生效
                    let halfVal = newWidth / 2;
                    imgItem.left = +imgItem.left - halfVal;
                    textItem.left = +textItem.left - halfVal;
                }
                imgItem.bottom = +imgItem.height + (+imgItem.top);
                textItem.bottom = +textItem.height + (+textItem.top);
                textItem.right = +textItem.left + (+textItem.width);
                imgItem.right = +imgItem.left + (+imgItem.width);
            },
            getExtendImgItem(tagName) {
                let idx = this.editorObj.data.findIndex((item) => {
                    return item.tagName === tagName && item.type === 'img';
                });
                if (idx === -1) {
                    return null;
                }
                return this.editorObj.data[idx];
            },
            async autoExtend(newWidth, newHeight, item) {
                let tagName = item.tagName;
                let imgItem = this.getExtendImgItem(tagName);
                if (imgItem === null || !item.direction) {
                    return;
                }
                let beforeWidth = 0;
                // let letterSpacing = this.getLetterSpacing(item.letterSpacing);
                // if (letterSpacing) { // getStyle 中额外添加了width宽度， 下面要减去，否则dom的width和item中不一致
                //   beforeWidth += letterSpacing + 5;
                // } else {
                //   beforeWidth += Math.ceil(item.fontSize / 10);
                // }
                let minusWidth = newWidth - (+item.width - beforeWidth);
                let minusHeight = newHeight - (+item.height);
                let newImgWidth = +imgItem.width + minusWidth;
                let newImgHeight = +imgItem.height + minusHeight;
                let base64 = null;
                if (item.direction === img_horizontal && minusWidth !== 0) { // 先横向扩展
                    base64 = await util.extendImgForHorizontal(imgItem.url, minusWidth).catch(() => {
                    });
                } else if (item.direction === img_vertical && newImgHeight !== 0) {
                    base64 = await util.extendImgForVertical(imgItem.url, minusHeight).catch(() => {
                    });
                } else {
                    if (minusWidth !== 0) {
                        base64 = await util.extendImgForHorizontal(imgItem.url, minusWidth).catch(() => {
                        });
                    }
                    if (newImgHeight !== 0) {
                        base64 = await util.extendImgForVertical(base64, minusHeight).catch(() => {
                        });
                    }
                }
                if (base64) {
                    this.$emit('onAddCache');
                    uploadService.uploadFileByBase64(base64).then(({url, properties}) => {
                        let arr = properties.split('x');
                        imgItem.width = arr[0];
                        imgItem.height = arr[1];
                        item.width = newWidth;
                        imgItem.url = url;
                        if (imgItem.direction !== img_horizontal) {
                            item.height = arr[1];
                        }
                        this.setItem(imgItem, item, minusWidth, item.textAlign === 'center');
                    });
                }
            },
            onEditorTextFocus(ev, item, index) {
                if (item.disabled) {
                    return;
                }
                this.validateTextLen(ev, item);
                this.textHeight = ev.target.offsetHeight;
                this.textWidth = ev.target.offsetWidth;
                this.activeIndex = {};
                this.$set(this.activeIndex, index, true);
                this.$emit('onEditorTextFocus', ev, index);
                this.focusInputEvent = ev;
            },
            onDrop(ev, item, index) {
                if (this.preview || item.disabled) {
                    return false;
                }
                this.$emit('onDrop', ev, index);
            },
            onTextAllowDrop(ev, item) {
                if (item.disabled) {
                    return false;
                }
                this.$emit('onTextAllowDrop', ev, item);
                ev.preventDefault();
                return false;
            },
            onAllowDrop(ev, item, index) {
                if (this.preview || index === 0 || item.disabled === true) {// 老数据可能没有disabled属性
                    return false;
                }
                this.$emit('onImgAllowDrop', ev, item);
                ev.preventDefault();
            },
            onDragenter(ev) {
                this.$emit('onDragenter', ev);
            },
            onDragleave(ev) {
                this.$emit('onDragleave', ev);
            },
            onDragend(ev) {
                this.$emit('onDragend', ev);
                return false
            },
            onImgClick(item, index) {
                this.$emit('onItemClick', index, item);
                if (this.isBg(item)) {
                    return;
                }
                if (item.disabled === true) { //edit有可能为空
                    return;
                }
                this.$store.commit('app/set_selected_img_index', index);
                this.$emit('onImgClick', index, item);
                this.toggleEditorOperation(true);
            },
            onImgDblclick(item, index) {
                this.$emit('onImgDblclick', {item, index});
            },
            onTextClick(ev, item, index) {
                this.$emit('onItemClick', index, item);
                if (item.disabled) {
                    return;
                }
                this.$store.commit('app/set_selected_img_index', index);
                this.$emit('onTextClick', ev, index, item);
            },
            onCompositionstart() {
                this.inputEnd = false;
            },
            onCompositionsend($event, item) {
                this.inputEnd = true;
                this.validateTextMaxLength($event, item);
            },
            onInput($event, item) {
                if (this.inputEnd) {
                    this.validateTextMaxLength($event, item);
                }
            },
            validateTextMinLength($event, item) {
                let textLen = $event.target.innerText.length;
                let minLen = +item.minLength;
                if (minLen > 0 && textLen < minLen) {
                    this.$message.error(`最少输入${minLen}个字符`);
                    $event.target.innerText = item.name;
                    return false;
                }
                return true;
            },
            validateTextMaxLength($event, item) {
                // if (!$event.data) {
                //     return;
                // }
                // let target = this.focusInputEvent.target;
                // let iptText = target.innerText;
                // let textLen = iptText.length;
                // let maxLen = +item.maxLength;
                // if (maxLen > 0 && textLen > maxLen) {
                //     this.$message.error(`最多输入${maxLen}个字符`);
                //     $event.target.innerText = item.name;
                //     this.setFocusPosition(target.lastChild, item.name.length);
                // }
            },
            setFocusPosition(dom, textLength) {
                if (!textLength) {
                    return;
                }
                let selection = window.getSelection();
                let range = document.createRange();
                range.setStart(dom, textLength);
                range.collapse(true);
                selection.removeAllRanges();
                selection.addRange(range);
            },
            showImgEditor(index, item) {
                this.toggleEditorOperation(false);
                this.$emit('onImgEditor', {index, item});
                this.$store.commit('app/set_selected_img_index', index);
            },
            onImgLoad(item) {
                this.$emit('onImgLoad', item);
            },
            isEdit(item) {
                if (this.preview || item.disabled === true) { // 老数据可能没有disabled属性
                    return false;
                }
                return true;
            },
            onOpenGroupDialog(index, item) {
                this.toggleEditorOperation(false);
                this.$emit('onOpenGroupDialog', item, index);
                this.$store.commit('app/set_selected_img_index', index);
            },
            onHide(index, item) {
                this.toggleEditorOperation(false);
                this.$emit('onHideItem', index, !item.hide);
                this.$store.commit('app/set_selected_img_index', index);
            },
            setTopForOtherGroupItem(item, value) {
                let pid = item.parentId;
                if (pid !== null && pid !== undefined) {
                    let top = +item.top;
                    let arr = this.editorObj.data.filter((obj) => {
                        return obj.parentId === pid && +obj.top > top && !obj.fixed;
                    });
                    if (arr && arr.length > 0) {
                        arr.forEach((gItem) => {
                            gItem.top = +gItem.top + value;
                        });
                    }
                }
            },
            onKeyup(ev, item){
              this.validateTextLen(ev, item);
            },
            onTextKeydown(ev) {
                if (ev.key === 'Enter') {
                    document.execCommand("insertHTML", false, "\n");
                    ev.preventDefault();
                }
                if (!this.inputting) {
                    this.inputting = true;
                    this.$emit('onAddCache');
                }
            },
            onTextInput(ev, item) {
                if (this.timeVal) {
                    window.clearTimeout(this.timeVal);
                    this.timeVal = null;
                }
                this.timeVal = setTimeout(() => {
                    let currentHeight = ev.target.offsetHeight;
                    let value = currentHeight - this.textHeight;
                    if (this.textHeight && value !== 0) {
                        this.textHeight = currentHeight;
                        this.setTopForOtherGroupItem(item, value);
                    }
                }, 200);
            },
            isGroupMaterial(item) {
                return item.isGroupMaterial && item.materialGroup;
            },
            toggleEditorOperation(trueOrFalse) {
                this.showEditorOperation = trueOrFalse;
            },
            onResizing(left, top, width, height, item) {
                requestAnimationFrame(() => {
                    this.updatePosition(left, top, width, height, item)
                })
            },
            onDragstop(left, top, item) {
                this.updatePosition(left, top, null, null, item);
            },
            updatePosition(left, top, width, height, item) {
                item.left = left;
                item.top = top;
                if (width && height) {
                    item.width = width;
                    item.height = height;
                }
                item.bottom = +item.height + (+item.top);
                item.right = +item.width + (+item.left);
                item.originData = item.originData ? item.originData : {};
                item.originData.left = item.left;
                item.originData.top = item.top;
                item.originData.bottom = item.bottom;
                item.originData.right = item.right;
                item.pRight = this.editorObj.width - item.right;
            },
            validateTextLen(ev, item) {
                this.errorItem = util.validateTextLen.call(this, ev, item.maxLength) ? item : null;
                if(!this.errorItem && window.moreTextErrorMsg){
                    this.$message.closeAll();
                }
            },
        }
    }
</script>
<style lang="scss" scoped>
  @import "editor-area";
</style>